import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BuyButton } from "@/components/BuyButton";
import { CtaSafetyBadges } from "@/components/CtaSafetyBadges";
import StickyMobileCta from "@/components/StickyMobileCta";
import { SectionHeading } from "@/components/SectionHeading";
import { Container } from "@/components/Container";
import { PreviewGallery } from "@/components/PreviewGallery";
import { STORE } from "@/constants/testIds";
import { ACCESS_TIMING_TEXT } from "@/data/content";

export default function Preview() {
  return (
    <div data-testid={STORE.previewPage}>
      <section className="bg-[var(--ibp-navy-950)] py-12 text-white sm:py-16">
        <Container>
          <SectionHeading
            tone="navy"
            kicker="Free Preview"
            title="See exactly what you’re getting."
            subtitle="Preview the Illinois Broker Prep online study platform: learning path, dashboard, state-law practice, answer review, score tracking, Word Bank, and timed review."
          />
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <BuyButton testId={STORE.previewBuyCta} size="lg" />
            <Link
              to="/product"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#E7BE4A] hover:underline"
            >
              See full product details <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <p className="mt-3 max-w-2xl text-xs leading-5 text-white/65">
            Access online from any modern browser — no download or app required.{" "}
            {ACCESS_TIMING_TEXT}
          </p>
        </Container>
      </section>

      <section className="bg-[var(--ibp-offwhite)] py-14 sm:py-20">
        <Container>
          <PreviewGallery />

          <div className="mt-10 rounded-2xl bg-[var(--ibp-navy-950)] p-8 text-center text-white">
            <h3 className="font-[var(--font-heading)] text-2xl font-semibold">
              Ready to start studying?
            </h3>
            <p className="mx-auto mt-2 max-w-md text-sm text-white/75">
              Get the Illinois Broker Prep learning system and study with source-backed lessons, timed review, explanations, and readiness tracking.
            </p>
            <div className="mt-6 flex justify-center">
              <BuyButton testId="preview-bottom-buy-cta" size="lg" />
            </div>
            <CtaSafetyBadges tone="navy" className="mt-6 justify-center" />
          </div>
        </Container>
      </section>
      <StickyMobileCta source="preview_sticky" />
    </div>
  );
}
